import breakpointsRaw from './breakpointsRaw';
import queries from './queries';

const fonts = Object.freeze({
  DomaineDisplay: 'font-family: "DomaineDisplay"; font-display: swap;',
  FoundersGrotesk: 'font-family: "FoundersGroteskText"; font-display: swap;',
  Pitch: 'font-family: "Pitch"; font-display: swap;'
});

const fontSizes = Object.freeze({
  '48': 'font-size: 48px;',
  '36': 'font-size: 36px;',
  '32': 'font-size: 32px;',
  '24': 'font-size: 24px;',
  '20': 'font-size: 20px;',
  '18': 'font-size: 18px;',
  '16': 'font-size: 16px;',
  '14': 'font-size: 14px;'
});

const colors = Object.freeze({
  aloe: '#bedcc8',
  beige: '#f0e6dc',
  beigeLight: '#f7f2ed',
  gray: '#c6c7ce',
  grayLight: '#f0f0f0',
  disabledGray: '#6a6a6a',
  night: '#343754',
  nightLight: '#727589',
  nightMedium: '#4b4e68',
  pink: '#f8d0c5',
  pinkLight: '#f7e1da',
  white: '#ffffff',
  yellow: '#ffe664',
  yellowLight: '#fcf6d6',
  yellowPastel: '#faf5f0',
  purple: '#353148',

  // DEPRECATED: Please add names from Zeplin as they're used
  KBYellow: '#FFE664',
  KBNight: '#343754',
  KBBeige: '#f7f2ed',
  KBWhite: '#FFFFFF',
  KBBlush: '#F8D0C5',
  KBPink: '#F4A598',
  KBGrey: '#F0F0F0',
  KBPale: '#f7f2ed',
  KBTan: '#F0E6DC',
  KBPaleYellow: '#FCF6D6',
  KBLightBlueGrey: '#c6c7ce',
  KBTwilightUltraLight: '#b0bec5',
  KBTwilightLight: '#727589',
  KBTwilightMed: '#63667C',
  KBTwilightDark: '#4B4E68',
  KBShadow: '#d8d8d8',
  KBError: '#9e272b',
  KBDarkBlue: '#343754',
  KBPalePink: '#f7e1da'
});

const layers = Object.freeze({
  kindbodyLogo: 3,
  footer: 100
});

const {
  desktop,
  smallDesktop,
  tabletLandscape,
  tabletPortrait,
  largePhonePortrait,
  phone
} = breakpointsRaw;

const breakpoints = {
  desktop: `${desktop}px`,
  smallDesktop: `${smallDesktop}px`,
  tabletLandscape: `${tabletLandscape}px`,
  tabletPortrait: `${tabletPortrait}px`,
  largePhonePortrait: `${largePhonePortrait}px`,
  phone: `${phone}px`,
  raw: breakpointsRaw
};

export default {
  fonts,
  fontSizes,
  colors,
  layers,
  queries,
  breakpoints
};
